import Component from "../../lib/Component.js";

const JustWatchWidget = ({ widgetSelector, element, preloadScriptId }) => {
  // Initialize any necessary state or variables here
  const widget = element || (widgetSelector ? document.querySelector(widgetSelector) : null);

  if (!widget) {
    return Component.noop();
  }

  const preloadScriptElement = document.getElementById(preloadScriptId);

  let state = widget.querySelector("iframe") ? "mounted" : null;

  const adjustWidgetHeight = ({ loadedHeight, emptyHeight, onLoaded, onEmpty }) => {
    let justWatchMarginAdjusterCounter = 0;
    let justWatchMarginAdjuster = window.setInterval(() => {
      const justWatchIframe = widget.querySelector("iframe");
      if (justWatchIframe) {
        const justWatchIframeHeight = parseInt(justWatchIframe.height);
        if (justWatchIframeHeight > loadedHeight) {
          onLoaded && onLoaded();
          if (justWatchIframeHeight < emptyHeight) {
            onEmpty && onEmpty();
          }
          window.clearInterval(justWatchMarginAdjuster);
        }
      }

      // kill the interval tester after 5 seconds anyway
      justWatchMarginAdjusterCounter++;
      if (justWatchMarginAdjusterCounter > 10) {
        window.clearInterval(justWatchMarginAdjuster);
      }
    }, 500);
  };

  return new Component({
    onMount: () => {
      if (state !== null) return;

      if (preloadScriptElement && widget) {
        state = "mounting";
        let justwatchScript = document.createElement("script");
        document.querySelector("body").appendChild(justwatchScript);
        justwatchScript.onload = () => {
          adjustWidgetHeight({
            loadedHeight: 20,
            emptyHeight: 60,
            onLoaded: () => {
              state = "mounted";
            },
            onEmpty: () => {
              widget.className += " justwatch-message";
            },
          });
        };
        justwatchScript.onerror = () => {
          if (process.env.NODE_ENV === "development") console.error("Failed to load JustWatch widget script.");
          state = null;
        };
        justwatchScript.src = preloadScriptElement.href;
      }
    },
    onUnmount: () => {
      // Cleanup logic when the component is unmounted
    },
    render: () => {
      // Rendering logic if needed
    },
  });
};

export default JustWatchWidget;
